import { Injectable } from '@angular/core';
import { SxHttpService } from './sxHttp.service';
import { PanelGrupoConItemsVM } from './config.service';
import { Observable } from 'rxjs/Observable';
import { Currency } from '../model/interfaces/currency.interface';

/**
 * Representa un PanelItemConfiguracionVM en el Backend
 */
export interface PanelItemOpcionesVM {
  commercialProductId: number;
  optionNumber: number;
  subscriptionCode: string;
  description: string;
  category: number;
  product: string;
  codPlan: string;
  codSubProduct: string;
  codInstalacionV5: string;
  codNegocio: string;
  codProducto: string;
  codProvider: string;
  currency: string;
}


@Injectable()
export class OpcionesService {
  url = 'api/configuracionOpcion';

  constructor(private sxHttp: SxHttpService) { }

  /**
   * Obtiene el listado de Assets asociados a un Producto
   *
   * @param codSistema
   * @param codNegocio
   * @param codSponsor
   * @param codProducto
   */
  getByProducto(codSistema: string, codNegocio: string, codProducto: string): Promise<PanelItemOpcionesVM[]> {
    const url = `${this.url}/${codSistema}/${codNegocio}/${codProducto}`;
    return this.sxHttp.get(url)
      .toPromise()
      .then(response => {
        return response.json().data
          .map(opciones => {
            return {
              commercialProductId: opciones.commercialProductId,
              optionNumber: opciones.optionNumber,
              subscriptionCode: opciones.subscriptionCode,
              description: opciones.description,
              category: opciones.category,
              product: opciones.product,
              codPlan: opciones.codPlan,
              codSubProduct: opciones.codSubProduct,
              codProvider: opciones.codProvider,
              currency: opciones.currency
            };
          }) as PanelItemOpcionesVM[];
      });
  }

  getByID(idOpcion: number): Promise<PanelItemOpcionesVM> {
    const url = `${this.url}/${idOpcion}`;
    return this.sxHttp.get(url)
      .toPromise()
      .then(response => response.json().data as PanelItemOpcionesVM);
  }

  crearOpcion(codSistema: string, codNegocio: string, codProducto: string,
    opcion: PanelItemOpcionesVM): Promise<PanelItemOpcionesVM> {
    const url = `${this.url}/${codSistema}/${codNegocio}/${codProducto}`;
    return this.sxHttp.post(url, opcion)
      .toPromise()
      .then(response => response.json().data as PanelItemOpcionesVM);
  }

  editarOpcion(opcion: PanelItemOpcionesVM): Promise<PanelItemOpcionesVM> {
    const url = `${this.url}`;
    return this.sxHttp.put(url, opcion)
      .toPromise()
      .then(response => response.json().data as PanelItemOpcionesVM);
  }

  eliminar(idOpcion): Promise<number> {
    return this.sxHttp.delete(`${this.url}/${idOpcion}`)
      .toPromise()
      .then(res =>
        res.json().data as number);
  }

  getExcelCurrency(idSuscription: string, systemCode: string, cell: string): Promise<string> {
    const getUrl = `${this.url}/${idSuscription}/${systemCode}/getCurrency/${cell}`;
    return this.sxHttp.get(getUrl)
    .toPromise()
    .then(response => response.json().data as string);
  }

  getCurrencies(): Observable<Currency[]> {
    const url = `${this.url}/getCurrencies`;
    return this.sxHttp.get(url).map(response => {
      return response.json().data as Currency[];
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/opciones.service.ts